import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/components/ui/accordion';
import { Typography } from '../typography';
import { Options } from '@/components/ui/combobox';

interface Props {
	options: Options[];
}

export const CustomAccordionOptions: React.FC<Props> = ({ options }) => {
	return (
		<Accordion type="single" collapsible>
			{options.map((item, index) => (
				<AccordionItem key={index} value={String(index)}>
					<AccordionTrigger className="hover:no-underline py-6">
						{/* <Typography type="bold-22" className="text-left">
							{item.}
						</Typography> */}
					</AccordionTrigger>
					<AccordionContent>
						<Typography type="regular-16" className="opacity-60">
							{item.label}
						</Typography>
					</AccordionContent>
				</AccordionItem>
			))}
		</Accordion>
	);
};
